import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function Footer() {
  const loc = useLocation();
  if (loc.pathname.startsWith("/admin")) return null;
  return (
    <footer data-testid="site-footer" className="border-t border-white/5 mt-24 bg-[#0A1628]">
      <div className="max-w-7xl mx-auto px-6 py-12 grid md:grid-cols-4 gap-10 text-sm">
        <div>
          <img
            src="/genquotes-logo.png?v=3"
            alt="GenQuotes"
            className="h-10 w-auto mb-3"
            style={{ maxHeight: 40 }}
          />
          <p className="text-[#94A3B8] leading-relaxed">
            Win more jobs with instant online quotes.
          </p>
        </div>
        <div>
          <div className="uppercase text-xs tracking-widest text-[#94A3B8] mb-3">Product</div>
          <ul className="space-y-2 text-[#F8FAFC]/80">
            <li><Link to="/" className="hover:text-[#06B6D4]">Overview</Link></li>
            <li><Link to="/pricing" className="hover:text-[#06B6D4]">Pricing</Link></li>
            <li><Link to="/get-started" className="hover:text-[#06B6D4]">Get started</Link></li>
            <li><Link to="/setup" className="hover:text-[#06B6D4]">Setup guide</Link></li>
          </ul>
        </div>
        <div>
          <div className="uppercase text-xs tracking-widest text-[#94A3B8] mb-3">Company</div>
          <ul className="space-y-2 text-[#F8FAFC]/80">
            <li><a href="/#faq" className="hover:text-[#06B6D4]">FAQ</a></li>
            <li><a href="/#free-consultation" className="hover:text-[#06B6D4]">Free consultation</a></li>
            <li><Link to="/account" className="hover:text-[#06B6D4]">Account</Link></li>
          </ul>
        </div>
        <div>
          <div className="uppercase text-xs tracking-widest text-[#94A3B8] mb-3">Legal</div>
          <ul className="space-y-2 text-[#F8FAFC]/80">
            <li><Link to="/terms" className="hover:text-[#06B6D4]">Terms</Link></li>
            <li><Link to="/privacy" className="hover:text-[#06B6D4]">Privacy</Link></li>
            <li><Link to="/admin" className="hover:text-[#06B6D4]">Admin</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 py-5 flex items-center justify-between text-xs text-[#94A3B8]">
          <div>© {new Date().getFullYear()} GenQuotes. All rights reserved.</div>
          <div className="font-mono">v2.0</div>
        </div>
        <div className="max-w-7xl mx-auto px-6 pb-5 text-xs text-[#94A3B8]" data-testid="footer-abn">
          ABN: 59487165324
        </div>
      </div>
    </footer>
  );
}
